var map = {
	"./avatar": 73,
	"./avatar.png": 73,
	"./banners/registration": 74,
	"./banners/registration.png": 74,
	"./black-back": 75,
	"./black-back.png": 75,
	"./csv_sample_image": 76,
	"./csv_sample_image.png": 76,
	"./feature/Conference-amico": 77,
	"./feature/Conference-amico.png": 77,
	"./feature/Researching-amico": 78,
	"./feature/Researching-amico.png": 78,
	"./feature/Selecting team-amico": 79,
	"./feature/Selecting team-amico.png": 79,
	"./logo": 80,
	"./logo.png": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;